export default "__VITE_ASSET__1c2de37f__"